import React from "react";

const EtTrinitySetPriorities = ({ userId, onClose }) => {

  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - Help user define top 2–3 priorities for the day

  return (
    <div className="p-4">
      <h3 className="text-lg font-bold text-gray-800 mb-2">Set Today’s Priorities</h3>
      <p className="text-sm text-gray-600 mb-2">[Let user set focus for key outcomes or meetings for today]</p>
      <button onClick={onClose} className="mt-4 text-sm text-blue-600 underline">Close</button>
    </div>
  );
};

export default EtTrinitySetPriorities;